import * as types from "./actionTypes";
import simulatieInfrastructuurApi from "../api/simulatieInfrastructuurApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";

// ----------------------------------------------------------------------------
export function simulatieInfrastructurenByDossierLoaded(infrastructuren) {
	return {
		type: types.INFRASTRUCTUREN_BY_DOSSIER_LOADED,
		body: {
			items: infrastructuren
		}
	};
}

export function loadInfrastructurenByDossierId(dossierId) {
	return function (dispatch) {
		dispatch(ajax.started());
		return simulatieInfrastructuurApi.getAllByDossierId(dossierId)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(simulatieInfrastructurenByDossierLoaded(response.data));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function saveInfrastructurenForDossier(infrastructuren) {
	return function (dispatch) {
		dispatch(simulatieInfrastructurenByDossierLoaded(infrastructuren));
	};
}
